<div class="dialog-container">
    <div mat-dialog-content>
        <div mat-dialog-title class="header3 confirm-text">
            <!-- <i-feather name="check-circle" class="check-icon"></i-feather> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="#43BC48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-check">
                <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span style="margin-left: 10px">Report updated successfully</span>
        </div>
    </div>
    <div class="button-container" mat-dialog-actions>
        <button mat-raised-button class="close-button" (click)="onNoClick()">Close</button>
    </div>
</div>